import { render, staticRenderFns } from "./PBIFiles.vue?vue&type=template&id=97b9fd62&"
import script from "./PBIFiles.vue?vue&type=script&lang=js&"
export * from "./PBIFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports